export type Language = 'nl' | 'en';

export const translations = {
    // Menu
    projects: { nl: 'Projecten', en: 'Projects' },
    mechanics: { nl: 'Monteurs', en: 'Mechanics' },
    logout: { nl: 'Uitloggen', en: 'Logout' },

    // Login
    username: { nl: 'Gebruikersnaam', en: 'Username' },
    password: { nl: 'Wachtwoord', en: 'Password' },
    login: { nl: 'Inloggen', en: 'Login' },
    register: { nl: 'Registreren', en: 'Register' },
    backToLogin: { nl: 'Terug naar inloggen', en: 'Back to login' },
    passwordsDoNotMatch: { nl: 'Wachtwoorden komen niet overeen.', en: 'Passwords do not match.' },
    signInToAccount: { nl: 'Log in op je account', en: 'Sign in to your account' },
    createNewAccount: { nl: 'Maak een nieuw account aan', en: 'Create a new account' },
    switchToEnglish: { nl: 'Schakel naar Engels', en: 'Switch to English' },
    switchToLanguage: { nl: 'Schakel naar Nederlands', en: 'Switch to English' },
    or: { nl: 'of', en: 'or' },

    // Projects
    addProject: { nl: 'Project toevoegen', en: 'Add Project' },
    project: { nl: 'Project', en: 'Project' },
    projectType: { nl: 'Type project', en: 'Project Type' },
    calculatedHours: { nl: 'Gecalculeerde uren', en: 'Calculated Hours' },
    remarks: { nl: 'Bijzonderheden', en: 'Remarks' },
    typeRemarksHere: { nl: 'Type hier bijzonderheden', en: 'Type remarks here' },
    add: { nl: 'Toevoegen', en: 'Add' },
    edit: { nl: 'Wijzigen', en: 'Edit' },
    search: { nl: 'Zoeken', en: 'Search' },

    // Mechanics
    addMechanic: { nl: 'Monteur toevoegen', en: 'Add Mechanic' },
    mechanic: { nl: 'Monteur', en: 'Mechanic' },
    name: { nl: 'Naam', en: 'Name' },
    type: { nl: 'Type', en: 'Type' },
    notes: { nl: 'Notities', en: 'Notes' },
    addNote: { nl: 'Notitie toevoegen', en: 'Add Note' },
    noNotes: { nl: 'Nog geen notities', en: 'No notes yet' },
    typeNoteHere: { nl: 'Typ hier een notitie...', en: 'Type a note here...' },
    description: { nl: 'Omschrijving', en: 'Description' },

    // Connect
    connectMechanic: { nl: 'Monteur koppelen', en: 'Connect Mechanic' },
    connectProject: { nl: 'Verbind project', en: 'Connect Project' },
    connect: { nl: 'Verbinden', en: 'Connect' },
    link: { nl: 'Koppelen', en: 'Link' },
    connectFailed: { nl: 'Koppelen mislukt.', en: 'Could not connect mechanic.' },
    mechanicAlreadyConnected: { nl: 'Deze monteur is al gekoppeld aan dit project.', en: 'This mechanic is already connected to this project.' },
    typeRequiredForConnect: { nl: 'Selecteer een werktype om de monteur aan te koppelen.', en: 'Select a work type to connect the mechanic to.' },
    mechanicAlreadyConnectedToType: { nl: 'Deze monteur is al gekoppeld aan', en: 'This mechanic is already connected to' },
    connectNotFound: { nl: 'Project of monteur niet gevonden.', en: 'Project or mechanic not found.' },
    connectForbidden: { nl: 'Geen toestemming om deze monteur te koppelen.', en: 'No permission to connect this mechanic.' },
    connectNetworkError: { nl: 'Netwerkfout, probeer het opnieuw.', en: 'Network error, please try again.' },

    // Week
    week: { nl: 'Week', en: 'Week' },
    hours: { nl: 'Uren', en: 'Hours' },
    percentageToCount: { nl: 'Percentage mee te rekenen', en: 'Percentage to count' },
    totalHours: { nl: 'Totaal aantal uren', en: 'Total Hours' },
    addWeek: { nl: 'Week toevoegen', en: 'Add Week' },
    weekNumber: { nl: 'Weeknummer', en: 'Week Number' },
    year: { nl: 'Jaar', en: 'Year' },
    percentToCount: { nl: 'Procent meerekenen', en: 'Percentage to count' },
    setAllWeeksPercentage: { nl: 'Percentage voor alle weken instellen', en: 'Set percentage for all weeks' },
    setAllWeeksPercentageWarning: {
        nl: 'Dit overschrijft het percentage van alle weken in deze koppeling.',
        en: 'This overwrites the percentage for every week in this link.',
    },

    // To-Do
    toDoList: { nl: 'To-Do Lijst', en: 'To-Do List' },
    addItem: { nl: 'Punt toevoegen', en: 'Add Item' },
    afterSalesItem: { nl: 'After-Sales punt', en: 'After-Sales item' },
    save: { nl: 'Opslaan', en: 'Save' },

    // Delete Confirmation
    deleteConfirmation: {
        nl: 'Weet je zeker dat je dit wilt verwijderen. Dit kan niet worden terug gedraaid.',
        en: 'Are you sure you want to delete this? This cannot be undone.'
    },
    confirm: { nl: 'Bevestigen', en: 'Confirm' },
    cancel: { nl: 'Annuleren', en: 'Cancel' },
    delete: { nl: 'Verwijderen', en: 'Delete' },

    // Print
    layout: { nl: 'Layout', en: 'Layout' },
    print: { nl: 'Printen', en: 'Print' },
    hoursOverview: { nl: 'Uren overzicht', en: 'Hours Overview' },
    noDataAvailable: { nl: 'Geen gegevens beschikbaar', en: 'No Data Available' },
    ensureProjectData: { nl: 'Zorg ervoor dat het project monteurs en geregistreerde uren heeft.', en: 'Please ensure project has mechanics and hours tracked.' },
    projectCode: { nl: 'Projectcode', en: 'Project Code' },
    total: { nl: 'Totaal', en: 'Total' },
    hoursWorked: { nl: 'Uren gewerkt', en: 'Hours Worked' },
    hoursEstimated: { nl: 'Uren geraamd', en: 'Hours Estimated' },
    result: { nl: 'Resultaat', en: 'Result' },
    remaining: { nl: 'resterend', en: 'remaining' },
    over: { nl: 'over gecalculeerde uren', en: 'over calculated hours' },
    hourSuffix: { nl: 'u', en: 'h' },

    // Mechanic Types
    mechanicType: { nl: 'Monteur', en: 'Mechanic' },
    helperMechanic: { nl: 'Hulpmonteur', en: 'Helper Mechanic' },
    helper: { nl: 'Hulp', en: 'Helper' },
    office: { nl: 'Kantoor', en: 'Office' },

    // Project Types
    bathroom: { nl: 'Badkamer', en: 'Bathroom' },
    kitchen: { nl: 'Keuken', en: 'Kitchen' },
    toilet: { nl: 'Toilet', en: 'Toilet' },
    projectTypes: { nl: 'Projecttypes', en: 'Project Types' },
    addProjectType: { nl: 'Type toevoegen', en: 'Add Type' },
    noType: { nl: 'Geen type', en: 'No type' },
    workType: { nl: 'Werktype', en: 'Work Type' },
    typeName: { nl: 'Typenaam', en: 'Type name' },

    // Registration
    registrationCode: { nl: 'Registratiecode', en: 'Registration Code' },
    invalidRegistrationCode: { nl: 'Ongeldige registratiecode.', en: 'Invalid registration code.' },

    // Materials
    materialsDelivered: { nl: 'Materiaal geleverd', en: 'Materials Delivered' },

    // Admin
    admin: { nl: 'Beheer', en: 'Admin' },
    adminPanel: { nl: 'Beheerpaneel', en: 'Admin Panel' },
    statistics: { nl: 'Statistieken', en: 'Statistics' },
    users: { nl: 'Gebruikers', en: 'Users' },
    activity: { nl: 'Activiteit', en: 'Activity' },
    totalProjects: { nl: 'Totaal projecten', en: 'Total Projects' },
    totalMechanics: { nl: 'Totaal monteurs', en: 'Total Mechanics' },
    totalHoursWorked: { nl: 'Gewerkte uren', en: 'Hours Worked' },
    totalHoursEstimated: { nl: 'Geraamde uren', en: 'Estimated Hours' },
    totalConnections: { nl: 'Koppelingen', en: 'Connections' },
    materialsDeliveredRatio: { nl: 'Materiaal geleverd', en: 'Materials Delivered' },
    mechanicsByType: { nl: 'Monteurs per type', en: 'Mechanics by Type' },
    projectsByType: { nl: 'Projecten per type', en: 'Projects by Type' },
    unknown: { nl: 'Onbekend', en: 'Unknown' },
    createdBy: { nl: 'Aangemaakt door', en: 'Created by' },
    isAdmin: { nl: 'Beheerder', en: 'Admin' },
    unlockAccount: { nl: 'Ontgrendel', en: 'Unlock' },
    accountLocked: { nl: 'Vergrendeld', en: 'Locked' },
    failedLogins: { nl: 'mislukte pogingen', en: 'failed logins' },
    editUser: { nl: 'Gebruiker bewerken', en: 'Edit User' },
    noUsers: { nl: 'Geen gebruikers gevonden.', en: 'No users found.' },
    loadingUsers: { nl: 'Gebruikers laden...', en: 'Loading users...' },
    couldNotLoadUsers: { nl: 'Kon gebruikers niet laden. Controleer de backend.', en: 'Could not load users. Check the backend.' },
    recentProjects: { nl: 'Recente projecten', en: 'Recent Projects' },

    // Extras (per mechanic-link)
    meerwerk: { nl: 'Meerwerk', en: 'Extra Work' },
    dhzWork: { nl: 'DHZ werk', en: 'DIY Work' },
    meerwerkHours: { nl: 'Meerwerk uren', en: 'Extra Work Hours' },
    dhzHours: { nl: 'DHZ uren', en: 'DIY Hours' },
    netLaborBurden: { nl: 'Netto arbeidsuren', en: 'Net Labor Burden' },
} as const;

export type TranslationKey = keyof typeof translations;
